import type { Entity } from '@platform/entities/entity.class';
import type { ColumnParams, DataType, RpcTable } from './types';

export function Column(dataType: DataType | [DataType], params?: ColumnParams) {
    return function (target: Entity, key: string) {
        const con = target.constructor as typeof Entity;
        if (!Object.prototype.hasOwnProperty.call(con, '_struct') || !con._struct) con._struct = { ...con._struct };
        con._struct[key] = { dataType, ...params };
    };
}

export function Table(tableInfo: RpcTable) {
    return function (target: typeof Entity) {
        target._tableInfo = tableInfo;
    };
}
